import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {saveUserAppData} from '../../../Api/userApi';
import TickerSearch from '../../../Components/TickerSearch/TickerSearch';
import ItemTable from './ItemTable';
import SelectedItems from './SelectedItems';
import { loadSectorsIndustries } from '../../../Store/slices/globalResources.slice';
import Button from '@mui/material/Button'
import {SaveRounded} from "@mui/icons-material";
import { Row, Tabs, Typography, Divider, Drawer } from 'antd';
const { Title, Text, Link } = Typography;
const { TabPane } = Tabs;

const BlacklistInstance = ({ blacklist, onClose }) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(true);
  const [title, setTitle] = useState(blacklist?.title || 'New Blacklist');

  const sectorList = useSelector(state => state.global.cache?.sectorsIndustries?.sector);
  const industryList = useSelector(state => state.global.cache?.sectorsIndustries?.industry);
  const subIndustryList = useSelector(state => state.global.cache?.sectorsIndustries?.sub_idustry);

  useEffect(() => {
    if (!sectorList || sectorList.length === 0) {
      dispatch(loadSectorsIndustries());
    }
  }, [dispatch]);

  const [selectedItems, setSelectedItems] = useState({
    sectors: [],
    industries: [],
    tickers: [],
    ...blacklist?.data,
  });

  const handleAddItem = (type, item) => {
    setSelectedItems(prevItems => ({
      ...prevItems,
      [type]: [...(prevItems[type] || []), item],
    }));
  };

  const handleRemoveItem = (type, itemToRemove) => {
    setSelectedItems(prevItems => ({
      ...prevItems,
      [type]: prevItems[type].filter(item => item !== itemToRemove),
    }));
  };

  const handleSaveBlacklist = () => {
    dispatch(saveUserAppData({
      appType: 'blacklist',
      title,
      data: selectedItems,
      id: blacklist?.id,
    }));
  };

  return (
    <Drawer
      open={visible}
      onClose={() => {setVisible(false); onClose?.();}}
      width={800}
    >
      <Row className={'py-4'} align={'middle'} justify={'space-between'}>
        <Title editable={{onChange: setTitle}} level={3}>{title}</Title>
        <Button startIcon={<SaveRounded/>} variant={'contained'} onClick={handleSaveBlacklist} type="primary">
          Save Blacklist
        </Button>
      </Row>
      <div style={{border: '1px dashed #ddd'}}>
        <Typography.Text style={{padding: '20px 30px 0 30px', fontWeight: '600'}}>Selected Items</Typography.Text>
        <SelectedItems items={selectedItems} onRemove={handleRemoveItem} />
      </div>
      <Tabs type="card">
        <TabPane tab="Tickers" key="1">
          <TickerSearch onTickersSubmit={(tickers) => {
            tickers.forEach(ticker => handleAddItem('tickers', ticker.symbol));
          }} />
        </TabPane>
        <TabPane tab="Sectors" key="2">
          <ItemTable
            selectedItems={selectedItems}
            onAdd={handleAddItem}
            onRemove={handleRemoveItem}
            sectors={sectorList}
            industries={industryList}
          />
        </TabPane>
      </Tabs>
    </Drawer>
  );
};

export default BlacklistInstance;
